import { render, staticRenderFns } from "./SectionMyChannels.vue?vue&type=template&id=695889bb&scoped=true&"
import script from "./SectionMyChannels.vue?vue&type=script&lang=js&"
export * from "./SectionMyChannels.vue?vue&type=script&lang=js&"
import style0 from "./SectionMyChannels.vue?vue&type=style&index=0&id=695889bb&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695889bb",
  null
  
)

export default component.exports